import { render, staticRenderFns } from "./CalendarEventEditorEmployee.vue?vue&type=template&id=b3fb5de0&scoped=true&lang=pug&"
import script from "./CalendarEventEditorEmployee.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fb5de0",
  null
  
)

export default component.exports